export const common = { // 公共
  inputContentTip: '请输入内容',
  sendKeywordTip: '告诉我发生了什么，我会寻找答案。如果我找不到你需要的答案，我会给你额外的帮助。',
  readArticle: '阅读文章',
  vsCodeSendSuc: '验证码已发送',
  industrySkillExist: '该行业标签已存在',
  industryExist: '该行业已存在',
  bindPhone: '绑定手机',
  bindEmail: '绑定邮箱',
  notSet: '未设置',
  alreadySet: '已设置',
  unbound: '未绑定',
  bound: '已绑定',
  networkException: '网络异常',
  momentAgo: '刚刚',
  minutesAgo: '分钟前',
  hourAgo: '小时前',
  weekAgo: '周前',
  monthsAgo: '月前',
  daysAgo: '天前',
  confirm: '确定',
  deleteTip: '确定删除吗?',
  describe: '描述',
  describeNullTip: '请填写描述',
  pleaseSelect: '请选择',
  inputNumTip: '请输入数值',
  operationFailed: '操作失败',
  remarks: '备注',
  successTip: '操作成功',
  reminder: '提示',
  saveSuc: '保存成功!',
  saveFailed: '保存失败!',
  searchTip: '请输入关键词',
  search: '搜索',
  toRecharge: '前往充值',
  login: '登录',
  logOut: '退出',
  signUp: '注册',
  home: '首页',
  project: '项目',
  myProject: '我的项目',
  bidProject: '竞标项目',
  postProject: '发布项目',
  allProject: '全部项目',
  exploreTopSkills: '探索顶尖技能',
  msg: '消息',
  chatMsg: '私信',
  P_E_T_S_C: '请输入搜索内容',
  page_total1: '共',
  page_total2: '条',
  changeLang: 'Change language',
  cancel: '取消',
  submit: '提交',
  close: '关闭',
  yes: '确定',
  analyst: '人才',
  customer: '雇主',
  bidder: '竞标者',
  reset: '重置',
  query: '查询',
  verificationCode: '验证码',
  tips: '温馨提示',
  bankCardTip: '您的银行卡信息(收款信息)未完善, 请先完善后再参与项目竞标.',
  userInfoTip1: '您的个人信息尚未完善, 请先去上传头像和修改姓名',
  userInfoTip2: '您的个人信息尚未完善, 请先去上传头像',
  userInfoTip3: '您的个人信息尚未完善, 请先去修改姓名',
  goTo: '前往',
  points: '点数',
  other: '其他',
  systemMessage: '系统消息',
  timedTaskManage: '定时任务管理',
  save: '保存',
  email: '邮箱',
  userName: '用户名',
  days: '天',
  recentContent: '近期精彩内容',
  sendCode: '获取验证码',
  resendCode: '重新发送验证码',
  uploadSuccess: '上传成功',
  uploadFailed: '上传失败',
  noData: '暂无数据',
  delete: '删除',
  feedback: 'Infotikx 平台使用反馈',
  feedbackTips: '请让我们知道发生了什么，我们会尽快回复您。',
  feedback: '反馈',
  feedbackChatTip: '请让我们知道发生了什么...',
  reply: '选填，我们将尽快回复您',
  footerCompany: 'InfoTikx是一个由Kcomber股份有限公司拥有和运营的品牌。',
  footerReserved: 'Kcomber股份有限公司,版权所有。',
  businessConsulting: '商业咨询',
  Tel: '电话',
  Email: '电子邮箱',
  currency: '人民币',
  payment: '一次性交付',
  byStages: '分期交付',
  renovate: '操作失败, 请刷新页面后再试!',
  ok: '好 的',
  noSet: "暂未设置",
  help: '我们能为您提供什么帮助？',
  categories: '类别',
  support: '帮助',
  verificationFailure: '校验失败',
  drag: '拖动滑块完成拼图',
  set: '设置',
  supports: "支持",
  collection:'我的收藏',
  collectionIsMore:'您的收藏列表已满，您可购买会员享受更多收藏位置以及其他功能',
  success:'收藏成功',
  noPoints:'点数不足',
  publicTotal:'私密竞标人数',
  loadingTip: '正在加载...',
  inviteProject: '请选择邀请竞标的项目',
  fireworksTips:'人才已经在路上',
  pleaseConfirm: '请确认',
  confirmNameTip1: '是否确认您的',
  confirmNameTip2: '角色名改为：',
  updateEmail: '并绑定邮箱地址：',
  updatePhone: '并绑定手机号码：',
  updateNicknameTip1: '角色名一年只能修改一次',
  updateNicknameTip2: '角色名和邮箱绑定一年只能修改一次',
  updateNicknameTip3: '角色名和手机绑定一年只能修改一次',
  mailboxValidated: '邮箱验证',
  phoneValidated: '手机验证',
  stop: '至',
  confirm: '确认',
  cancel: '取消',
  copyLink:'复制链接',
  shareLink:'分享你的信息',
  copyToClipboard:'复制到剪贴板',
  copuSuccess:'已复制',
  share:'分享',
  fillInTheNewInformation:'填写新增信息',
  transactionHistory: '交易历史',
  finance: '财务',
  myWallet: '我的钱包',
  recharge: '充值',
  chatting: '客服聊天'
}


export const login = { // 登录
  loginTip: '请先登录',
  login: '登录',
  signIn: '登录',
  passwordSignIn: '密码登录',
  emailSingIn: '验证码登录',
  phoneSingIn: '手机登录',
  forgotPassword: '忘记密码?',
  userName: '用户名',
  password: '密码',
  enterUserNameOrEmailOrPhone: '请输入用户ID、邮箱或手机号码',
  enterEmail: '请输入邮箱地址',
  enterPhone: '请输入手机号码',
  onlyChinesePhoneTip: '仅支持中国手机',
  emailAddress: '邮箱地址',
  inputPassword: '请输入密码',
  retrievePassword: '找回密码',
  retrievePasswordTip: '请填写您需要找回的帐号',
  nextStep: '下一步',
  enterYourEmail: '请您输入邮箱或账号',
  newPassword: '新密码',
  enterOldPassword: '请输入原密码',
  confirmNewPassword: '确认新密码',
  loginFailTip: '账号或密码不正确',
  userNameOrEmailOrPhone: '用户ID/邮箱/手机',
  notLoginTip: '未登录或登录超时，请登录',
  loginCodeError: '验证码错误',
  emailNotExistAccount: '该邮箱不存在对应的账号',
  phoneNotExistAccount: '该手机不存在对应的账号',
  enterEmailLoginCode: '请输入验证码',
  emailCodeLogin: '获取验证码',
  emailOrAccountErrorTips: '邮箱或账号不存在, 请重新输入',
  userInfoEmptyTip: '账号不存在',
  sendSuccess: '验证码发送成功,有效期15分钟',
  modifiedSuccess: '修改成功',
  isNoAnalyst: '人才角色无法发布项目，正在前往首页',
  isNoCustomer: '雇主角色无法竞标，正在前往首页',
  phone: '请输入手机号码',
}

export const signUp = { // 注册

  failToRegister700:"注册失败，请检查输入的内容",
  failToRegister1001:"用户名不可为空",
  failToRegister1002:"用户密码不能为空",
  failToRegister1010:"账号名不可包含[@]符",
  failToRegister1011:"账号名不能是纯数字",
  failToRegister1003:"账户长度必须在2到20个字符之间",
  failToRegister1004:"密码长度必须在5到20个字符之间",
  failToRegister1005:"注册失败，该用户名已注册",
  failToRegister1006:"注册失败，该邮箱已注册",
  failToRegister1007:"注册失败，该手机号已注册",
  emailExists: '该邮箱已注册',
  noSpacesAllowed:"不可以是空格",
  alreadyAccountTip: '已有账号? 去登录',
  protocolTipTwo: '《用户协议及条款》',
  protocolTipOne: '阅读并接受',
  protocolUncheckedTip: '请勾选"阅读并接受应方讯用户协议"',
  chooseRoleTip: '请选择您的角色',
  signUpFromPhoneTip01: '请输入您的手机号码，您将收到我们的注册验证短信，或',
  signUpFromPhoneTip02: '使用您的邮箱注册',
  signUpFromEmailTip01: '请输入您的电子邮件地址，您将收到我们的注册验证电子邮件，或',
  signUpFromEmailTip02: '使用您的手机号码注册',
  phoneNullTip: '请输入手机号码',
  phone: '手机号码',
  registerViaEmail: "邮箱注册",
  registerViaPhone: "手机注册",
  signUpError: '系统异常, 注册失败',
  userNameExists: '用户名已存在',
  parameterException: '参数异常',
  codeErrorTip: '验证码错误',
  FailedToChangePassword1012:"修改密码失败，旧密码错误",
  FailedToChangePassword1013:"新密码不能与旧密码相同",
  keyError:"邮箱或手机异常",
  emailExistTip: '该邮箱已注册在其他账号上!',
  phoneExistTip: '该手机已注册在其他账号上!',
  resend: '重新发送',
  resendCodeTip: '重新发送验证码',
  sendCodeErrorTip: '服务不可用, 验证码发送失败, 请稍后再试',
  sendCodeSucTip: '验证码已发送',
  sendCodeSuc10Tip: '验证码已发送, 有效时间10分钟',
  sendCodeSuc15Tip: '验证码已发送, 有效时间15分钟',
  sendCodeEmailErrorTip: '验证码发送失败, 邮箱地址不能为空',
  registerSuccessTip: '注册成功!',
  enterVerificationCodeTip: '请输入验证码',
  greaterThan6CharTip: '不能少于6个字符',
  inputPasswordTip: '请输入密码',
  enterOldPassword: '请输入原密码',
  emailErrorTip: '请输入正确的邮箱地址',
  phoneErrorTip: '请输入正确的手机号码',
  enterEmailTip: '请输入邮箱',
  enterNicknameTip: '请输入昵称',
  greaterThan60Characters: '不能大于60个字符',
  enterUserNameTip: '请输入用户名',
  getVerificationCode: '获取验证码',
  passwordInconsistentTip: '两次输入密码不一致',
  enterPasswordAgainTip: '请再次输入密码',
  signUp: '注册',
  userName: '用户名',
  password: '密码',
  enterUserName: '请输入用户名',
  inputPassword: '请输入密码',
  confirmPassword: '确认密码',
  nickname: '昵称',
  email: '邮箱',
  emailOrPhone: '邮箱/手机',
  verificationCode: '验证码',
  mailboxBeingValidated: '正在进行验证的邮箱',
  retrievingAccountTip: '您正在找回的账号: ',
  ToHire: '找人才',
  findWork: '找工作',
  EmailCode:'获取邮箱验证码'


}

export const project = { // 项目相关
  createNewProject: '创建新项目',
  projectDetails: '项目详情',
  bidOwnProjectTip: '不能竞标自己发布的项目',
  projectId: '项目ID',
  update: '更新',
  skills: '技能',
  industryAndSkill: '行业及技能',
  evaluation: '评价',
  projectCase: '项目案列',
  effective: '未过期',
  beOverdue: '已过期',
  evaluated: '待评价',
  beOverdueProject: '过期项目',
  canceled: '已取消',
  projectTitleExist: '项目名已存在',
  paymentProportionsTop: '付款比例的总和必须为100%',
  projectProportionsTop: '项目比例之和必须为100%',
  proportionsTip: '总比例不够100%',
  daysEmptyTop: '日期不能为空',
  upLoadMaxTop: '您最多只能上载3个附件',
  badeTip: '您已参与了竞标, 再次提交可修改竞标信息.',
  stage: '分期交付',
  repeatBiddingTip: '您已参与过该项目的竞标, 请勿重复提交',
  projectNotInBidding: '提交失败, 该项目已结束竞标',
  publicProject: '公开项目',
  privateProjectNotInvTip: '私有项目, 至少需要邀请一位talent',
  privateProjectTip: '勾选为私有项目, 只有受到邀请的talent才能查看及参与竞标',
  privateProject: '私有项目',
  costTip: '请输入费用',
  cost: '费用',
  durationTip: '请输入工期',
  duration: '工期',
  next: '下一步',
  fileSizeErrorTip: '该文件大小超出限制大小, 系统已将其从上传列表剔除, 请重新上传!',
  fileTypeErrorTip: '不支持上传该文件格式, 系统已将其从上传列表剔除, 请重新上传!',
  editProjectTip: '该项目处于竞标/交易/验收状态, 请谨慎修改项目内容. 修改后系统将自动发送邮件通知竞标者及中标者(如有), 是否继续?',
  saveAndPost: '保存并发布',
  existTip: '已存在, 请勿重复添加!',
  invitationTip: '该用户查询不到, 您可输入他的邮箱地址给他发送邀请邮件!',
  registeredEmailInvited: '待发送注册邀请邮箱',
  analystsInvited: '待邀请的人才',
  enterProjectDuration: '请输入项目工期',
  enterBudgetTip: '请输入预算',
  relProPointsTip: '本次发布项目需要点数',
  pointsCurrentlyOwnedTip: '您当前拥有的点数',
  all: '全部',
  unpublished: '待发布',
  noBid: '未中标',
  bidding: '竞标中',
  trading: '交易中',
  inReview: '验收中',
  completion: '已完成',
  closed: '已关闭',
  bidder: '竞标人',
  releaseTime: '发布时间',
  C_T_V_P_D: '点击查看项目详情',
  biddingProject: '竞标项目',
  joinBid: '参与竞标',
  postProject: '发布项目',
  postProjectSucTip: '项目发布成功',
  bidProject: '竞标项目',
  projectTitle: '项目标题',
  category: '类别',
  subCategory: '子类别',
  projectDescription: '项目描述',
  requiredSkills: '所需技能',
  budget: '预算 (元)',
  budgetDuration: '预算工期(天)',
  durationMin: '最短预算工期 (天)',
  durationMax: '最长预算工期 (天)',
  durationMinTip: '请输入最短预算工期 (整数)',
  durationMaxTip: '请输入最长预算工期 (整数)',
  biddingDeadline: '投标截止时间',
  attachFile: '附加文件',
  additionalDocumentDescription: '最多可上传5个附件, 文件最大20MB, 支持格式.jpg,.png,.pdf,.docx,.doc,.xlsx,.xls,.pptx,.ppt,.rar,.zip',
  additionalDocumentDescription2: '最多可上传1个附件, 文件最大20MB, 支持格式.jpg,.png,.pdf,.docx,.doc,.xlsx,.xls,.pptx,.ppt,.rar,.zip',
  markAsFeatured: '标记为特色',
  invitationAnalyst: '邀请人才',
  paymentMethod: '支付方式',
  wechatPay: '微信',
  aliPay: '支付宝',
  offlineTransfer: '线下转账',
  payAndSubmit: '支付并发布',
  iHavePaid: '我已支付',
  enterTitle: '请输入标题',
  selectCategory: '请选择类别',
  selectSubCategory: '请选择子类别',
  titleMinCharacter: '请输入最少10个字符',
  titleMaxCharacter: '请输入控制在最多255字符内',
  enterProjectDescription: '请输入项目描述',
  descriptionMinCharacter: '请输入最少30个字符',
  descriptionMaxCharacter: '请输入控制在最多4000字符内',
  selectRequiredSkills: '请选择所需技能',
  selectDeadlineForBidding: '请选择投标截止时间',
  editProject: '编辑项目',
  allCategory: '全部类别',
  skills: '技能',
  budgetScope: '预算范围',
  budgetMax: '最大预算',
  budgetMin: '最小预算',
  budgetMaxTip: '请输入最大预算(整数)',
  budgetMinTip: '请输入最小预算(整数)',
  featured: '特色',
  nothing: '无',
  biddingProjectRemarksTip: '请输入竞标备注信息',
  clickToDownload: '点击下载',
  projectDetails: '项目详情',
  tradeDetails: '交易详情',
  uploadAttachment: '上传附件',
  uploadAttachmentTip: '最多可上传3个附件',
  remark: '备注',
  submitRemark: '提交备注',
  deliver: '交付',
  enteringTheAcceptanceStage: '进入验收阶段',
  enteringTheAcceptanceStageTip: '您确定进入验收阶段吗?',
  checkAndAccept: '验收',
  currentPhase: '当前交付阶段',
  attachments: '附件',
  analystRemark: '人才备注信息',
  acceptancePassed: '验收通过',
  acceptancePassedTip: '您确定该项目已通过验收吗?',
  acceptanceFailed: '验收不通过',
  acceptanceFailedTip: '您确定驳回该项目吗?',
  onlyNewComers: '新人',
  successfulBidder: '中标者',
  choice: '选择',
  select: '选择',
  releaseTime: '发布时间',
  deadline: '截止日期',
  projectTreatyTip: '请先阅读并同意《InfoTikx服务条款》',
  projectTreaty: '我已阅读并同意',
  pay: '支付',
  aliPayTip: '请用支付宝扫一扫支付',
  weChatPayTip: '请用微信扫一扫支付',
  researchFeeOrder: '项目费用订单',
  goToBidding: '前往竞标',
  containsEmailTips: '不建议出现邮箱电话等信息,系统默认把邮箱电话等信息替换成xx...xx',
  biddingTips: '总投标金额和总投标工期预算',
  file: '附件',
  fileLimit3: '最多只能上传1个附件',
  fileLimit4: '最多只能上传5个附件',
  isRemove: '是否移除',
  deleteSuccess: '删除成功!',
  previousStep: '上一步',
  pleaseEnter: '请输入数字',
  successfully: '发布成功',
  whatCanweDo: '需要我们帮你做什么',
  improveInformation: '继续完善项目信息',
  submitInformation: '提交资料，我们会快速帮你匹配专业的服务人员',
  tellprojectTitle: '告诉我们项目标题',
  aboutProject: '告诉我们项目更多的描述信息',
  uploadFile: '上传文件',
  projectInformation: '你已提交的项目基本信息',
  fillInformation: '继续填写一下信息就可以发布项目',
  costBudget: '项目费用预算',
  expect: '预计工期',
  expectTime: '预计工期',
  deliveryType: '项目交付类型',
  publication: '项目发布类型',
  outward: '公开招标',
  secret: '私密招标',
  preview: '预览项目信息',
  expectedCompletion: '预计完成工期',
  cutOffDate: '竞标截止日期',
  saveDraft: '保存草稿',
  userAgreement: '《InfoTikx用户协议》',
  inviteEmail: '邀请人才邮箱',
  invitationEmail: '邀请邮箱',
  inviteTalents: '邀请人才',
  InviteBidding: '邀请人才竞标',
  cooperate: '与您合作过的人才',
  selectProject: '请选择你的项目',
  postbox: '邮箱格式不正确',
  remove: '移除',
  addStages: '添加分期',
  invitation: '邀请竞标',
  hire: '雇佣',
  progress: '进行中的项目',
  toBeReleased: '待发布的项目',
  closedItems: '已结束的项目',
  isPrivate: '是否私密',
  skillRequirements: '技能要求',
  endTime: '距结束时间还剩',
  estimate: '预计工期',
  completionTime: '预期完成工期',
  averageBiddingAmount: '平均竞标金额',
  numberOfBidders: '个竞标',
  successfulBidder: '中标者',
  projectInfo: '项目信息',
  biddingList: '竞标列表',
  endOfBidding: '投标已结束',
  projectNo: '项目编号',
  deadlineBidding: '竞标截止时间',
  exposedType: '公开类型',
  paymentType: '项目支付类型',
  employer: '项目雇佣者',
  biddingInformation: '填写竞标信息',
  biddingAmount: '竞标金额',
  bestCandidate: '是什么让你成为这个项目的最佳人选?',
  bid: '前往竞标',
  averageBid: '平均出价',
  noMoreData: '没有更多数据',
  invitationList: '已添加至邀请列表',
  alreadyExists: '该人才已邀请！',
  maximum: '最多邀请5位人才',
  matching: '平台正在快速匹配人才',
  recruit: '招贤纳士',
  backToHome: ' 秒后返回首页',
  backToProject: ' 秒后跳至项目',
  cooperation: '确定合作',
  startChat: '发起聊天',
  initiateCooperation: '发起合作',
  projectBudget: '费用预算',
  release: '发布于',
  bidEnd: '截止',
  expirationTime: '过期时间',
  projectCompletionTime: '项目完成时间',
  projectExposedType: '项目公开类型',
  deliveryMethod: '交付方式',
  projectCost: '项目费用',
  projectProgress: '项目进度',
  attachmentContent: '附件内容',
  records: '查看详细记录',
  deliverables: '交付成果',
  deliveryPhase: '交付阶段',
  results: '成果正在制作中...',
  evaluationInformation: '评价信息',
  evaluationScore: '对你的评价分数',
  evaluateComments: '对你的评价内容',
  detailRecord: '详情记录',
  startTime: '项目启动时间',
  addDeliverables: '上传文件',
  Failure: '验收不通过',
  Accepted: '验收通过',
  noComments: '暂未有评价信息',
  beenCommented: '对方已提交评价，您需要评价后才显示对你的评价',
  checkStage: '当前验收阶段',
  yesOrNo: ', 是否确定验收通过? 通过后项目费用将会从平台释放到中标者账户。',
  failed: ', 验收不通过',
  failedReason: '请填写不通过的原因',
  caht: '聊天',
  failedReason1: '请填写验收不通过说明的原因!',
  public:'公开竞标',
  nonPublic:'私密竞标',
  tips2:'  (花费5点数',
  tips1:'免费次数:',
  noChange:'竞标类型无法修改',
  achivement:'成就任务',
  isInvite:'已邀请',
  veryPoor:'非常差',
  disappointed:'差',
  average:'一般',
  satisfied:'满意',
  surprised:'非常满意',
  paymentSummary: '付款摘要',
  requested: '请求放款',
  inProgress: '项目进行中',
  releaseMoney: '释放金额',
  requestCreate: '请求创建',
  created: '已创建',
  funded: '已付款',
  releaseRequested: '请求释放佣金',
  released: '佣金已释放',
  reject: '已拒绝',
  accept: '接受',
  refuse: '拒绝',
  payment: '付款',
  milestone: '里程碑',
  milestonePayments: '里程碑费用',
  milestoneAmount: '里程碑金额',
  milestoneDescription: '里程碑描述',
  status: '状态',
  inputAmount: '请输入金额',
  inputDesc: '请输入描述',
  endProject: '结束项目',
  milestoneNo: '里程碑编号',
  proposals: '竞标信息',
  files: '上传文件',
  paymentInfo: '付款信息',
  invalidBid: '无效竞标',
  retractBidTips: '确认撤销当前竞标吗？',
  retractBidding: '撤回',
  releaseConfirm: '确认释放里程碑',
  releaseConfirmTips:'请确保您对工作感到满意，因为里程碑付款一旦发放就无法退回，项目将变为完成状态。',
  confirmCloseProject: '确认结束项目',
  closeProjectTips:'项目取消后将变为关闭状态。',
  requestCancel:'请求取消',
  canceled:'已取消',
  uploadFileTips: '请先上传成果文件',
  cancelProjectTips: '项目有进行中的里程碑是无法取消的',
  withdrawCancel: '撤回取消',
  completeProjectRadio: '我对所有项目要求均已得到满足，项目已完成',
  closeProjectRadio: '关闭项目',
  disputing: '争议中',
  createDispute: '创建争议',
  viewDispute: '查看争议'
}

export const user = { // 用户相关
  informationIntroduction: '信息介绍',
  hisProfile: '个人资料',
  currentlyBoundPhone: '当前绑定的手机',
  currentlyBoundEmail: '当前绑定的电子邮件',
  modifyBoundEmail: '修改绑定的电子邮件',
  enterUserIdTip: '请输入用户ID',
  enterNickNameTip: '请输入用户角色名称',
  modifyUserId: '修改用户ID',
  modifyNickName: '修改角色名',
  bindPhoneTip: '手机绑定后，您可以使用手机登录',
  phoneBinding: '手机绑定',
  verificationType: '其他方式验证',
  noEmail: '当前账号没有绑定相关邮箱！',
  refuseToSend: '当前帐户没有绑定到相关的电子邮件!',
  refuseToSend: '该邮箱注册未满7天不能用于换绑！',
  phoneTip: '(您可以用手机登录，手机号码一年只能更改一次)',
  updateNickNameTip: '一年只能修改一次',
  modifyUserIdTip: '只能修改一次',
  modifyEmailTip: '电子邮件地址每年只能更改一次',
  registrationDate: '注册时间',
  modify: '修改',
  binding: '绑定',
  bindingUpdate: '绑定',
  accountSecurity: '账户安全',
  idAlreadyExists: 'ID已存在',
  idCannotContainTip: 'ID不能包含`@`、`!`、`$`、`?`、`&`、`#`、`*` 等特殊符号',
  idStartWithUserTip: 'ID不能以`user_`开头',
  idMaxLengthTip: 'ID不能大于20个字符',
  idMinLengthTip: 'ID不能小于6个字符',
  nicknameLengthTip: "用户名必须介于3到16个字符之间",
  idAllNumTip: 'ID不能为纯数字',
  idEmptyTip: 'ID不能为空',
  nickNameTip: '角色名称不能为空',
  nickkNameTip2: '角色名称必须以字母开头',
  nickkNameTip3: '角色名重复，换一个试试呢',
  nickkNameTip4: '请填写合法的姓名',
  retrievingPasswordUserIdTip: '正在找回密码的用户ID',
  useEmailToValidateTip: '使用电子邮箱验证',
  usePhoneToValidateTip: '使用手机号验证',
  emailBeingVerifiedTip: '正在验证的电子邮箱',
  phoneBeingVerifiedTip: '正在验证的手机号',
  emailNotBoundTip: '未绑定邮箱',
  phoneNotBoundTip: '未绑定手机',
  canNotUpdateByKeyTip: '您不能通过该方式重置密码',
  updatePasswordError: '修改密码失败',
  mailboxInUse: '正在使用的邮箱',
  chooseRoleAanExplain: '人才投标并实施项目，以获得服务的好处。',
  chooseRoleCusExplain: '雇主发布他们的需求，并与平台内的优质服务提供商合作。',
  currentUserId: '当前用户ID',
  currenntNickName: '当前角色名',
  userId: '用户ID',
  user: '用户',
  userType: '用户类型',
  personal: '个人中心',
  myProfile: '我的资料',
  editProfile: '编辑资料',
  changePassword: '修改密码',
  bankCard: '银行信息',
  setNewPassword: '设置新密码',
  account: '用户名',
  password: '密码',
  enterNewPassword: '请输入新密码',
  submit: '提交',
  safetyVerification: '安全验证',
  updatePasswordTips: '为保障账号安全, 修改密码前需要验证身份',
  verifyMailbox: '邮箱验证',
  verificationCode: '验证码',
  getCaptcha: '获取验证码',
  newPasswordEmptyTips: '新密码不能为空',
  resendVerificationCode: '重新发送验证码',
  myProfile: '我的概况',
  aboutMe: '关于我',
  totalRevenue: '总收入',
  totalSpent: '总花费',
  completedProjects: '已完成项目',
  ongoingProjects: '正在进行的项目',
  nickname: '昵称',
  email: '邮箱',
  phone: '电话',
  type: '类型',
  skills: '技能',
  level: '级别',
  entry: '入门',
  reviews: '评论',
  avatar: '头像',
  editAvatar: '更换头像',
  addAvatar: '头像',
  editAvatarTip: '只能上传jpg/jpeg/png文件',
  score: '评分',
  reviewsAndRatingsTip: '亲, 写点评价吧, 你的评价对其他Customer有很大帮助的.',
  evaluationContentCannotBeEmpty: '评价内容不能为空',
  youHavenScoredYet: '您还未打分',
  userStatistics: '用户统计',
  accountId: '用户ID',
  evaluateSucTip: '评价成功!',
  relatedItems: '相关项目',
  noComment: '暂无任何评论和评分',
  profile: '资料',
  mySettings: '我的设置',
  privacySettings: '隐私设置',
  otherSettings: '其他设置',
  showAllItem: '显示全部项目数量',
  displaysUnsuccessful: '显示未中标项目数量',
  displaysReleased: '显示待发布项目数量',
  displaysBid: '显示竞标中项目数量',
  displaysTransaction: '显示交易中项目数量',
  displaysAcceptance: '显示验收中项目数量',
  displaysCompleted: '显示已完成项目数量',
  displaysClosed: '显示已关闭项目数量',
  displayEvaluation: '显示评价和评分',
  avatarReview: '头像审核',
  mailboxRelated: '邮件相关',
  receiveBiddingEmail: '开启竞标邮箱通知',
  AvatarModifiedSuccessful: '头像修改成功!',
  AvatarModifiedFailed: '头像修改失败!',
  ResendAfter1: '',
  ResendAfter2: 's后重新发送',
  sendSuccess: '发送成功',
  BasicInfo: '基本信息',
  tips1: '用户类型和用户姓名尚未认证，',
  tips2: '前往认证',
  Character: '用户角色',
  UserID: '用户ID',
  UserType: '用户类型',
  Individual: '个人',
  Company: '公司',
  Services: '服务信息',
  Skill: '服务技能',
  Contact: '联系方式',
  PhoneNumber: '电话号码',
  Email: '邮箱',
  Country: '国家/地区',
  Province: '州/省/区域',
  city: '城市',
  Detailed: '详细地址',
  PostalCode: '邮政编码',
  Medals: '奖牌勋章',
  MyMedals: '勋章展示',
  Picture: '资质照片',
  CompanyName: '公司名称',
  Unbound: '未绑定',
  tips3: '请先绑定手机号，',
  tips4: '去绑定',
  DocumentType: '证件类型',
  DocumentNo: '证件编号',
  DocumentPhotocopy: '证件照片',
  CompanyType: '公司类型',
  BusinessLicense: '证件类型',
  BusinessLicenseNo: '证件编号',
  LicensePhotocopy: '证件照片',
  tips5: '以上信息是我个人真实有效信息',
  tips6: '以上信息是我司真实有效信息',
  customer: '雇主',
  analyst: '人才',
  NotAuthenticated: '未验证身份',
  UserName: '用户姓名',
  DataCompleteness: '资料完善度',
  PleaseSelect: '请选择',
  PleaseEnter: '请输入',
  save: '保存',
  cancel: '取消',
  tips7: '行业服务技能选择',
  tips8: '请选择公司类型',
  tips9: '用户名不能为空',
  tips10: '请选择证件类型',
  tips11: '请输入证件号',
  tips12: '请勾选信息属实确认框',
  tips13: '公司名称不能为空',
  tips14: '请选择公司类型',
  tips15: '请选择证件类型',
  tips16: '输入证件编号',
  tips17: '请勾选信息属实确认框',
  tips18: '请输入用户名',
  withdrawal: '我的钱包',
  accountFunds: '账户资金',
  WithdrawalTips: '提款提示',
  tips19: "线下提款预计会在7-15个工作日内转入您的账户",
  tips20: '请上传头像',
  AccountBalance: '账户余额',
  withdraw: '提现',
  WithdrawalsRecord: '提现记录',
  startDate: '开始时间',
  endDate: '结束时间',
  ApplicationDate: '提现申请日期',
  WithdrawalAmount: '提现金额',
  AccountsReceivable: '到账账户',
  WithdrawalStatus: '提现状态',
  aboutME: '关于我',
  privateEnterprise: '私企',
  stateOwnedEnterprise: '国企',
  IDNumber: '身份证',
  passport: '护照',
  BusinessRegistration: '商业注册',
  other: '其他',
  ExcellentTest: '测试优秀',
  punctual: '准时',
  highQuality: '高质量',
  UnboundPhone: '未绑定,前往绑定手机',
  UnboundEmail: '未绑定,前往绑定邮箱',
  FullName: '真实姓名',
  uploadDescription: '只能上传jpg/png/jpeg文件，且不超过2MB',
  withdrawMoreDay:'提现次数已达到今日上限',
  withdrawMoreMon:'提现次数已达到本月上限',
  NumberOfWithdrawalsThisMonth:'本月剩余可提现次数',
  moreSkill:'技能数超过当前会员等级限制',
  currentTip: '当前',
  countryTip: '请选择当前国家/地区',
  notificationsettings:'通知设置',
  onlineMessage:'站内信',
  email:'邮件',
  messageNotification:'系统通知',
  financialNotice:'财务通知',
  memberNotification: '会员通知',
  projectRelated: '项目相关',
  descTips: '描述不能为空',
  amountTips: '金额不合法！',
  amountTips1: '金额不能为0！',
  amountTips2: '金额不能为空！',
  amountTips3: '不能大于里程碑金额！',
  checkUserInfoTip1: '请添加头像和修改您的名称',
  checkUserInfoTip2: '请添加头像',
  checkUserInfoTip3: '请修改您的名称',
}

export const msg = { // 消息相关
  msgCenter: '消息中心',
  all: '全部',
  title: '标题',
  sendTime: '发送时间',
  operate: '操作',
  show: '查看',
  close: '关闭',
  chatMsg: '在线聊天',
  chatTip: '请输入内容',
  send: '发送',
  sendMsgTip: '不能发送空白信息',
  startPrivateChat: '发起私聊',
  remarkRepeat: '您已提交, 请勿重复提交',
  content:'内容',
  isAll:'所有信息已经加载完毕',
  onlineService:'在线客服',
  markAsRead: "标记为已读",
  markUnread: "标记为未读",
  markAllAsRead: "全部已读",
  markAllUnread: "全部未读",
  allReadConfirm: '此操作将设置全部消息为已读, 是否继续?',
  allUnreadConfirm: '此操作将设置全部消息为未读, 是否继续?',
  readConfirm: "确定要设置这条消息为已读吗？",
  unreadConfirm: "确定要设置这条消息为未读吗？",
  noMsg:'暂无消息',
  chatRules:'聊天规则',
}

export const bankCard = { // 银行账户相关
  perfectBankCardTip: '您的银行卡信息未完善',
  myBankCard: '我的银行卡',
  bankCardType: '账户类型',
  personal: '个人',
  mechanism: '机构',
  bankAccountName: '银行账户名',
  bankAccount: '银行账号',
  nameOfBankOfDeposit: '开户银行名',
  bankBranch: '支行名称',
  save: '保存',
  editBankCardTip: '如无和InfoTikx签订协议，请自行申报个税',
  SetAsDefault: '设为默认',
  AddBankCard: '新增银行卡',
  holderName: '请输入持卡人姓名',
  bankName: '请输入银行名称',
  bankAddress: '请输入开户行地址',
  bankNo: '请输入银行编号',
  bankCardNo: '请输入银行卡账号',
  manageBankCards: '管理银行卡',
  addACard: '设置银行卡信息',
  bankCardMaxTip: '最多绑定5张银行卡',
  withdrawalOfAmount: '金额提现',
  arrivalAccount: '到账账户',
  addCard: '添加新的银行账户',
  withdrawer: '提现金额',
  amount: '请输入提现金额',
  balance: '余额',
  tips1: '阅读并接受',
  agreement: '提现服务协议',
  tips2: '请勾选“阅读并接受《提现服务协议》',
  withdrawalNo: '提现单号',
  createTime: '提现申请日期',
  applyMoney: '提现金额',
  bankCardNo: '银行卡号',
  status: '提现状态',
  updataTime: '审批时间',
  application: '申请中',
  success: '提现成功',
  fail: '提现失败',
  failureReason: '提现失败原因',
  chinaBankCard: '中国银行卡',
  internationalBankCard: '国际银行卡',

}

export const points = { // 点数相关
  pointsInadequateTip: '您的点数不足, 请先充值后再发布项目!',
  selectedBudgetPointsTip: '已选择充值额度, 请选择支付方式进行支付,',
  points: '点数',
  myPoints: '我的点数',
  pointsRecharge: '点数充值',
  pointsRecord: '点数记录',
  rechargeAmountTip: '请输入充值金额',
  myAccountVoucher: '我的账户点数',
  paymentAmount: '支付金额',
  wechatPay: '微信支付',
  alipay: '支付宝支付',
  walletPay: '钱包支付',
  recharge: '立即充值',
  reminder: '温馨提示',
  pointTip: '西美积分无使用期限，您可用于发布项目、竞标项目等',
  rechargeSucTip: '充值成功',
  totalPointsCountAR: '充值后总点数数量',
  changeTime: '变更时间',
  beforeChange: '变更前点数',
  changeQuantity: '变更数量',
  afterChange: '变更后点数',
  reason: '变更原因',
  recharged: '充值',
  postProject: '发布项目',
  registeredGift: '注册赠送',
  nopoints:'点数余额不足，前往充值',
  achivement:'成就系统',
  achivementr:'成就',
  progress:'进度',
  receiveAward: '领取奖励',
  received: '已领取'


}

export const recharge = { // 充值相关

  selectedBudgetPointsTip: '已选择充值额度, 请选择支付方式进行支付,',
  recharge: '充值',
  myRecharge: '钱包充值',
  recharge: '充值',
  rechargeRecord: '充值记录',
  changeRecord: '交易记录',
  rechargeAmountTip: '请输入充值金额',
  myAccountVoucher: '我的钱包余额',
  paymentAmount: '支付金额',
  wechatPay: '微信支付',
  alipay: '支付宝支付',
  recharge: '立即充值',
  reminder: '温馨提示',
  pointTip: 'InfoTikx电子钱包是Infotikx为用户打造的电子账户，集余额支付、点数购买和管理、推广券兑换于一体，适用于InfoTikx官网支付项目款项，管理个人余额和绑定银行卡等',
  rechargeSucTip: '充值成功',
  totalPointsCountAR: '充值后钱包余额',
  changeTime: '变更时间',
  beforeChange: '变更前余额',
  changeQuantity: '变更数量',
  afterChange: '变更后余额',
  reason: '变更原因',
  recharged: '充值',
  rechargedPoints: '充值点数',
  postProject: '发布项目',
  payProjectFee: '支付项目费用',
  acceptProjectFee: '项目佣金入账',
  registeredGift: '注册赠送',
  nextTip: '我已完成支付,点击下一步',
  payMilestones: '支付里程碑费用',
  acceptMilestones: '里程碑佣金入账',
  refundMilestones: '里程碑佣金退款',
  payArbitrationFee: '支付仲裁费用',
  refundArbitrationFee: '仲裁费用退款',
  payIdentityFee: '支付认证费用',
  stripePayTips:'支付金额小于¥4.00，不支持使用Stripe支付',
}

export const admin = { // 后台管理界面相关
  selfHelpQAndA: '自助问答',
  actualEntry: '实入账',
  entryTime: '入账时间',
  accountsReceivable: '应入账',
  recordStatus: '入账状态',
  unrecorded: '未入账',
  recorded: '已入账',
  industryAndSkill: '行业及技能',
  edit: '编辑',
  name: '名称',
  billToBePaid: '待付单',
  pendingReceipt: '待收单',
  statementType: '对账单类型',
  subjectMatter: '标的',
  uncollected: '未收款',
  received: '已收款',
  receivedStatus: '收款状态',
  receivedTime: '收款时间',
  paymentChannel: '支付渠道',
  realPayment: '实付款',
  currentPeriod: '当前期数',
  paymentStatus: '支付状态',
  actuallyReceived: '项目实收款',
  receivables: '项目应收款',
  platformFee: '平台服务费',
  totalFee: '总金额',
  payable: '应付款',
  analystName: '人才名称',
  customerName: '雇主名称',
  projectName: '项目名称',
  projectPeriod: '项目期数',
  projectManage: '项目管理',
  operationGuidanceEdit: '操作指南管理',
  homePageSetting: '首页设置',
  systemSetting: '系统设置',
  pointsManage: '点数管理',
  basicSettingsOfPoints: '点数基础设置',
  rechargeOrder: '充值订单',
  platformUserStatistics: '平台用户统计',
  userManagement: '用户管理',
  totalPlatformUsers: '平台总用户量',
  total: '总量',
  newUsersThisMonth: '本月新增用户',
  paymentType: '支付方式',
  paymentTime: '支付时间',
  orderNumber: '订单号',
  projectId: '项目ID',
  creatorId: '创建人ID',
  createTime: '创建时间',
  orderStatus: '订单状态',
  money: '金额(元)',
  unpaid: '待支付',
  failed: '支付失败',
  successful: '支付成功',
  closed: '已关闭',
  enterOrderNumberTip: '请输入订单号',
  enterProjectIDTip: '请输入项目ID',
  systemIdentificationCode: '识别码',
  base: '基数',
  explain: '说明',
  savePointsBaseTip: '确定保存吗?',
  orderManagementOfCountingAndRecharging: '点数充值订单管理',
  pointsIncome: '点数进账情况',
  entered: '已进账',
  unEntered: '未进账',
  user: '用户',
  pointsNum: '点数值',
  sendingSystemMsg: '发送系统消息',
  enterMsgTitleTip: '请输入消息标题',
  sendToAll: '发送给所有人',
  sendToAllCus: '发送给所有Customer',
  sendToAllAna: '发送给所有Talent',
  filterByCondition: '按条件筛选',
  sendSystemMsgTip: '确定发送吗?',
  sendMail: '同时发送邮件',
  registrationTime: '注册时间',
  msgTitleEmptyTip: '消息标题不能为空!',
  msgContentEmptyTip: '消息内容不能为空!',
  msgReceiverEmptyTip: '请先筛选出接收人!',
  msgSendSucTip: '消息发送成功!',
  msgSendFailTip: '消息发送失败!',
  avatar: '头像',
  operation: '操作',
  userAvatarReview: '用户头像审核',
  modificationTime: '修改时间',
  adopt: '通过',
  fail: '不通过',
  whyFail: '不通过详情',
  template: '模板',
  details: '详情',
  operationSucceeded: '操作成功!',
  operationFailed: '操作失败!',
  operationSucceededAndNotice: '操作成功,并成功发送消息通知该用户!',
  pleaseEnter: '请输入内容',
  areYouSure: '确认通过吗？',
  memberManagement: '会员管理',
  basicSettingsOfVip: '会员基础设置',
  platformFeeRateSetting: '平台服务费费率设置',
  projectCommission: '项目佣金手续费率',
  arbitrationFee: '仲裁服务费',
  minimumCost: '最低费用',
  memberPurchaseOrder: '会员购买订单',
  annualFee: '年费',
  monthlyFee: '月费',
  monthlyPrice: '价格 / 月',
  monthlyOriginalPrice: '原价 / 月',
  yearPrice: '价格 / 年',
  yearOriginalPrice: '原价 / 年',
  memberPurchaseOrderManagement: '会员购买订单管理',
  monthsPurchased: '购买的月数',
  memberIncome: '会员进账情况',
  purchasedMembers: '购买的会员',
  projectCostManagement: '项目费用管理',
  platformFeeManagement: '平台费用管理',
  arbitrationManagement: '仲裁管理',
  authManagement: '认证管理',
  billManagement: '账单管理',
  userStatement: '用户对账单',
  analystStatement: '人才对账单',
  userBill: '用户账单',
  analystBilling: '人才账单',
  paymentMethod: '收款方式',
  collectionAccount: '收款账户',
  skillsSet: '技能设置',
  withdrawal: '提现管理',
  withdrawalApproval: '提现审批',
  WithdrawalRecord: '审批记录',
  feedback: '反馈处理',
  help: '帮助中心',
  withdrawalAgreement: '提现协议',
  systemContent: '系统文本',
  activeUsers: '活跃用户',
  multipleVisits:'二次访问用户',
  lastLoginTime: '最后登录时间',
  sumLogin: '登录次数',
  published: '发布项目次数',
  biddingSum: '参与竞标次数',
  undertakedSum: '承接项目次数',
  finishSum: '完成项目次数',
  clientGrade: '雇主评分',
  talentGrade: '人才评分',
  goodViews: '好评数量',
  badViews: '差评数量',
  showActiveUsers: '仅显示活跃用户',
  registerTimeStart: '注册时间(起)',
  registerTimeEnd: '注册时间(止)',
  completed: '已完成',
  pending: '待处理',
  applicationUserId:'申请人Id',
  applicationUserName:'申请人用户名',
  applicationTime:'申请时间',
  creatorName:'创建人',
}

export const pay = { // 支付相关
  weChatPay: '微信支付',
  aliPay: '支付宝支付',
  walletPay: '钱包支付',
  payType: '支付方式',
  paymentAmount: '支付金额',
  platformFee: '平台服务费',
  orderPrice: '项目费用',
  paid: '我已支付',
  payConfirm: '确认支付',
  paySucTip: '支付成功',
  payFailTip: '未查询到支付信息',
  InsufficientBalance: '余额不足',
  projectCostTip: '该费用为项目费用,费用将由InfoTikx平台保管,待项目验收通过后,项目费用才支付给Talent',
  paymentInformation: '支付信息',
  paymentMatters: '该支付款项为项目费用，成功支付后该款项暂由Infotikx平台保管；当您同意释放金额后，该款项将自动发放到对应人才账户。',
  payMilestoneMatters: '该支付款项为里程碑费用，成功支付后该款项暂由Infotikx平台保管；当您选择释放里程碑佣金后，该款项将自动发放到对应人才账户。',
  payArbitrationMatters: '该支付款项为仲裁费用，如果您仲裁成功，该款项会返回到您的钱包。',
  createMilestoneMatters: '客户将需要批准这些更新，我们会通知他们，并告知您这些更改是否获得批准。',
  cancelPay: '已取消支付',
  payByWalletTip: '是否使用钱包支付?'
}

export const stage = { // 项目分期相关
  stageMinTip: '分期不能小于两期',
  phase: '阶段',
  days: '天数',
  closingDate: '截止日期',
  projectProportion: '项目比例',
  paymentProportion: '支付比例',
  delivery: '交付情况',
  currentDeliveryPhase: '当前交付阶段',
  pass: '通过',
  fail: '不通过',
  done: '已完成',
  notDone: '未完成'
}

export const history = { // 项目历史相关
  publishProject: '发布项目',
  winningBid: '中标',
  uploadProduct: '上传附件',
  deleteProduct: '删除产品',
  submitComments: '提交备注',
  acceptancePassed: '验收通过',
  acceptanceFailed: '验收不通过',
  projectCompletion: '项目完成',
  paymentReceived: '项目费用已支付',
  trading: '交易中',
  review: '评价',
  cancel: '项目取消',
  dispute: '争议中'
}

export const chatSystemMsg = { // 实时聊天相关
  tipOne: '对方未回复, 您无法继续发送消息'
}

export const vip = { // 会员相关
  memberUpgrade: '会员升级',
  vip: '会员',
  vipCenter: '会员中心',
  nonVip: '普通用户',
  silverVip: '普通会员',
  goldMedalVip: '黄金会员',
  platinumVip: '白金会员',
  purchaseRecord: '购买记录',
  hello: '您好',
  upgradeVipGainPrivileges: '升级为会员，尊享更多会员特权',
  member: '会员',
  honorable: '您好,尊贵的',
  expirationTime: '到期时间',
  monthly: '/1个月',
  yuanMonth: '元/月',
  originalPrice: '原价',
  renewNow: '立即续费',
  buyVip: '开通会员',
  annually: '/1年',
  vipPrivileges: '会员特权',
  purchaseTime: '购买时间',
  formerlyVipState: '购买前会员状态',
  purchasedVip: '购买的会员',
  purchasedDuration: '购买时长(单位:月)',
  upgradeVip: '升级为会员',
  wechatScan: '打开微信“扫一扫”',
  alipayScan: '打开支付宝“扫一扫”',
  scanningPayment: '扫描下方二维码完成支付',
  openingTime: '开通时长',
  oneMonth: '1个月',
  threeMonths: '3个月',
  sixMonths: '6个月',
  oneYear: '1年',
  paymentMethod: '支付方式',
  wechatPay: '微信',
  aliPay: '支付宝',
  paymentAmount: '支付金额',
  yuan: '元',
  explain: '说明 : 会员服务开通后不支持退款',
  buyNow: '立即购买',
  cancel: '取 消',
  successTips: "已成功购买会员",
  openVipFirst: '开通普通会员',
  openVipSecond: '开通黄金会员',
  openVipThird: '开通白金会员',
  renewalVipFirst: '续费普通会员',
  renewalVipSecond: '续费黄金会员',
  renewalVipThird: '续费白金会员',
  upgradeVipSecond: '升级为黄金会员',
  upgradeVipThird: '升级为白金会员',
  upgradeNow: "立即升级",
  validUntil: "有效期至",
  morePrivilege: '尊享更多特权',
  calculationUpgradePriceError: '获取差价失败, 请联系客服!',
  tips:'当前页面仅作简单范本展示'

}
export const search = { // 搜索功能相关
  industrySkills: '行业&技能',
  select: '选择',
  budget: '预算范围',
  duration: '项目工期(天)',
  release: '发布时间',
  status: '项目状态',
  public: '是否公开',
  sort: '排序',
  all: '全部',
  default: '默认',
  today: '今天',
  week: '一周内',
  twoWeeks: '半个月内',
  month: '一个月内',
  threeMonths: '三个月内',
  overThree: '超过三个月',
  notExpired: '未过期',
  expired: '已过期',
  public: '公开项目',
  private: '私有项目',
  budgetScope: '预算范围',
  projectDuration: '项目工期',
  SkillRequirements: '技能需求',
  joinBid: '前往竞标',
  deadline: '结束时间',
  releaseTime: '发布时间',
  biddingTotal: '竞标人数',
  BudgetDuration: '工期',
  grade: '星级',
  publishProject: '发布项目',
  more: '大于 360',
  completed: '完成项目数',
  oneStar: '一星及以上',
  twostars: '二星及已上',
  threestars: '三星及已上',
  fourstars: '四星及已上',
  fiveStars: '五星',
  moreThan500: '大于500',
  days: '天',
  recently: '最新的',
  highestPrice: '最高价',
  maximumDuration: '工期最多',
  bestEvaluation: '评价最高',
  clearOptions: '清除选项',
  moreFive: '最多选择5个标签',
  inviteWarn: '不能邀请自己'
}
export const index = { //首页
  toHire: '找人才',
  tips1: '寻找人才并聘请他们，让您的业务更上一层楼。',
  findWork: '找项目',
  tips2: '你有顶尖技能，为你的技能找合适的工作。',
  bestPick: '评价Top10',
  GoodBargin: '高性价比Top10',
  bestNewcomer: '新人Top10',
  latestPosts: '近期精彩内容',
  more: '更多',
  talent: '人才',
  project: '项目',
  bannerTitle: '在线上，雇佣最优秀的人才',
  bannerText: '全球80亿人，Infotikx帮助您找到心仪的人才',
  bannerTitle1: '在线上，寻找到最适合您的项目',
  bannerText1: '全球80亿人，Infotikx帮助您发挥您的才能，找到您最期望的项目',
  bannerTitle2: '在线上，雇佣最优秀的人才，寻找最适合自己的项目',
  bannerText2: '找工作还是找人才? 全球80亿人，Infotikx平台将带给您最好的用户体验',
  toHire: '找人才',
  findwork: '找工作',
  seationTitle: '需要完成某些工作？',
  seationTitle1: "“三省效益”，杜绝内卷",
  postJob: '发布工作',
  chooseInfotikx: '选择 Infotikx',
  paySafely: '安全支付',
  help: '我们在此提供帮助',
  browsePortfolios: '省钱，你的需求，你来定价',
  fastBids: '省时，你急速发布，他快速回复',
  qualityWork: '省事，不再为繁杂业务焦虑',
  Trackprogress: '跟踪进度',
  seationPart1: '发布一份工作是免费的并且很方便。只需填写标题、描述和预算，并在几分钟内竞标。',
  seationPart2: '无论任务规模是大还是小。我们有任何规模或预算的人才，他们拥有超过1800种技能。没有什么工作是太复杂的。我们都可以助您完成！',
  seationPart3: '只有当它已经完成并对交付内容100%满意时，才需要使用我们的里程碑付款系统支付款项。',
  seationPart4: '我们才华横溢的招聘团队可以找到最好的人才为您工作，我们的技术助手还可以为您管理项目。',
  seationPart5: '无论你是找人才还是找雇主，零支付就可以发布你的需求，并且还可以获得免费的项目报价。根据你的需求来定制薪酬，抛弃繁琐薪资计算，一个项目一个价格，杜绝不必要的开销。',
  seationPart6: '简单便捷的工作发布系统，让你三步之内就完成发布。人才竞标实时同步，让你不错过任何一个行业精英，提高你的业务效率，加速获得您想要的结果。',
  seationPart7: '我们团队可以找到最好的人才为您工作，同时我们的技术助手还可以为您管理项目，跟踪项目进度。直到项目完成且你对项目100%满意，才需要支付，让你支付安全无忧。',
  seationPart8: '用我们的时间追踪器和移动应用程序保持最新进度和活跃。永远知道Infotikx在做什么。',
  seeMore: '查看更多',
  footSeationTitle1: '远程工作？自由支配不是梦',
  footSeationTitle2: '公司预算？事半功倍',
  footSeationText1: '打造全球的远程灵活用工平台，促进人才的创造和流动',
  footSeationText2: '在云端整合跨国人才资源，突破区域限制，节省人力成本',
  joinUs: '找工作',
  findTalent: '找人才',
  ContactUs: '联系我们',
  tel: '电话',
  email: '电子邮箱'
}
export const role = { // 角色相关
  changeRole: '切换角色',
  currentRole: '当前角色',
  roleNickname: '角色名',
  joinTiem: '加入时间',
  personalIntroduction: '个人介绍',
  caseIntroduction: '案例介绍',
  comments: '项目评论',
  evaluationScore: '对他的分数评价分数',
  evaluationContent: '对他的评价内容',
  resume: '浏览简历',
  myWorks: '我的作品',
  individualWorks: '个人作品',
  clickupload: '点击上传',
  friendlyReminder: '温馨提醒',
  upgradeMember: '升级会员',
  uploadTip1: '当前只能上传',
  uploadTip2: '个文件作品，提升会员等级可以上传更多作品~',
  deleteTip: '此操作将从列表中删除该文件, 是否继续?',
}
export const bill = { // 账单相关
  statement: '我的对账单',
  myBill: '我的账单',
  payProjectFee: '支付项目佣金',
  receiveProjectFee: '收到项目佣金',
  payMilestone: '支付里程碑佣金',
  receiveMilestone: '收到里程碑佣金',
  payPlatformFee: '支付平台服务费',
  rechargePoints: '充值点数',
  rechargeWallet: '充值钱包',
  rechargeVip: '充值vip',
  date: '日期',
  transaction: '交易记录',
  amount: '金额',
  balance: '余额',
  payByWechat: '微信支付',
  payByAli: '支付宝支付',
  payByWallet: '钱包支付',
}
export const dispute = { // 争议
  stage:'阶段',
  stage1:'识别问题',
  stage2:'谈判',
  stage3:'最终建议或证据',
  stage4:'仲裁',
  stage1Tips1:'大多数争议都是简单的误解导致的。',
  stage1Tips2:'我们的争议解决系统旨在让双方自行解决问题。',
  stage1Tips3:'大多数争议都可以通过调解来解决。',
  stage1Tips4:'如果无法达成协议，任何一方都可以选择支付仲裁费用，由我们的争议团队来解决此事。',
  stage2Tips1:'Infotikx强烈建议您与对方进行清晰的沟通，以解决问题。',
  stage2Tips2_1:'注意：如果人才在提出争议后，雇主14天内未能进行回应，将有利于人才。',
  stage2Tips2_2:'注意：如果雇主在提出争议后，人才4天内未能进行回应，将有利于雇主。',
  stage2Tips3:'双方任何一方在4天后可以选择支付一定的仲裁费用，将争议升级到第三阶段。在此阶段期间，另一方将有4天时间同意支付该费用，并提交最终证据。仲裁结束后，仲裁费用将退还给争议的胜利者。',
  stage3Tips1:'如果任何一方拒绝解决争议并支付仲裁费，则争议进入此阶段。这是你们解决彼此之间纠纷的最后机会，也是你们提交证据支持案件的最后机会。',
  stage4Tips1:'争议小组将审查提供的所有证据和其他信息，以做出决定（通常在 48 小时内）。争议判决是最终的、有约束力的和不可逆转的。',
  disputeDescTips:'请详细描述您想争议的里程碑要求：',
  disputeUploadFileTips1:'确保您已经上传了每个里程碑要求完成的证据。请包括如何传达里程碑要求的证据。',
  disputeUploadFileTips2:'您可以附上您的案例。',
  solution:'解决方案',
  inProgress:'进行中',
  cancelled:'已关闭',
  resolved:'已解决',
  overdue:'超时未响应',
  arbitration:'仲裁中',
  waitResponse:'等待回应',
  success:'成功',
  failure:'失败',
  disputeAmount:'争议总金额',
  createTime:'发起时间',
  negotiations:'谈判',
  createDispute:'创建争议',
  wait:'等待',
  response:'回复',
  wantReceive:'希望得到：',
  releaseAmount:'同意',
  acceptArbitration:'接受仲裁',
  cancelDispute:'取消争议',
  applyArbitration:'申请仲裁',
  releaseAmountTips:'确认操作？',
  applyArbitrationTips1:'确认接受仲裁吗？',
  cancelDisputeTips:'确认取消争议？',
  applyArbitrationTips2:'确认仲裁吗？',
  disputeTitle:'解决争议流程',
  uploadFileTips: '最多可上传1个附件, 支持格式.jpg,.png',
  overdueTips:'超时系统已自动处理',
  viewEvidence:'查看证据',
  arbitrationSuccess:'仲裁成功',
  arbitrationFail:'仲裁失败',
  applyArbitrationTips:'谈判四天后才可以申请仲裁',
  disputeNo:'争议编号',
  evidenceList:'证据列表',
}
export const auth = { // 认证
  liftPotential:'提升你的潜力。',
  getVerified:'获得InfoTikx的验证',
  bannerDesc:'通过InfoTikx的验证，将您的个人资料提升到一个新的水平。 蓝色徽章让人们知道您的帐户是真实的，并且您已经完成了包括视频采访在内的身份验证流程。',
  accessDesc:'通过InfoTikx验证：',
  bannerList1:'价值 2,500.00 美元以上的项目',
  bannerList2:'每小时项目超过 50 美元',
  bannerList3:'更轻松地赢得更多工作',
  standTitle1:'在人群中脱颖而出',
  standContent1:'花更少的时间狩猎，更多的时间获胜。 经过验证的自由职业者将获得独特且高度识别的徽章，以确保客户首先注意到他们，从而增加他们获得奖励的机会。让客户来找你而不是浪费出价。',
  standTitle2:'增加信心',
  standContent2:'通过 InfoTikx 验证意味着您已经与 InfoTikx 员工进行了视频面试过程。 这将帮助客户将您识别为经过身份验证的 InfoTikx 会员。',
  standTitle3:'投标价值 2,500.00 美元+的项目',
  standContent3:'通过 InfoTikx 验证，可以独家访问更长、更有趣、报酬更高的项目。 只有经过 InfoTikx 验证才能投标价值 2,500.00 美元或以上的项目。',
  standLine:'获得验证后，我开始赢得更多项目。 我的客户非常感谢我采取额外的步骤来验证自己。它消除了很多摩擦。',
  clientTitle:'向客户展示个人资料背后的人！',
  clientContent:'通过 InfoTikx 验证，您可以向客户展示为什么您是该工作的完美自由职业者。 您的出价还将通过动画边框脱颖而出，从而提高出价的可见性。 您的出价被讨论和获奖的可能性提高了25%！',
  gettingTopTitle:'入门很简单',
  gettingTitle1:'需要什么？',
  gettingTitle2:'多久时间？',
  gettingTitle3:'流程是怎样的？',
  getting1Desc1:'要申请，您必须拥有最新的个人资料并且：',
  getting1Desc2:'电子邮件已验证',
  getting1Desc3:'电话已验证',
  getting1Desc4:'付款已验证',
  getting1Desc5:'KYC 已验证',
  getting2Desc:'申请后我们的代理将开始审查您的申请。 此过程通常会在 1 到 2 个工作日内完成。',
  getting3Desc:'在审核您的申请后，我们的一位代理将与您联系以安排视频面试。 如果您的面试成功，您的新蓝色“已验证”徽章将被激活。',
  gettingBottomDesc:'即使您最终没有满足成为经过验证的自由职业者的要求，申请费也不予退还。 如需了解更多信息，请参阅我们的常见问题解答。',
  winTitle:'更轻松地赢得更多工作',
  winDesc:'客户希望与认真对待自己职业生涯的值得信赖的自由职业者合作。InfoTikx 验证告诉客户您已采取额外步骤让他们知道您是认真的。',
  getStarted:'开始认证',
  successDialogTitle:'您已被验证',
  waitDialogTitle:'您已经提交了申请，请耐心等待后台审核',
  inProgressDialogTitle:'您距离通过验证只差一步',
  inProgressTips:'验证过程包括检查您的验证文件、您的个人资料，还可能与我们的团队进行视频通话。 提交申请后，我们将与您联系。',
  successTips:'恭喜！您的申请已获得批准，您已获得我们平台的认证。您现在可以开始接受任务、展示您的技能并与用户协作。 感谢您选择我们，期待您在这里继续取得成功！',
  waitTips:'感谢您提交申请！您的申请已成功发送至我们的审核团队，我们将尽快审核。 感谢您选择我们的平台，我们期待与您建立合作伙伴关系！',
  errTips:'您似乎缺少继续验证流程的一些要求。请完成这些以继续。',
  requirement:'要求',
  profileVerified:'个人信息验证',
  paymentVerified:'银行卡验证',
  KYCVerified:'身份验证',
  profileVerification:'完成个人资料验证',
  paymentVerification:'完成银行卡验证',
  kycVerification:'完成实名认证',
  here:'这里',
  failReason:'不通过原因',
  inputReason:'请输入失败原因',
  reason:'原因',
  applicationFailed:'您的申请已被拒绝',
}

export const userDetails = {
  back: '返回',
  avatar: '头像',
  nickname: '昵称',
  auth: '实名认证',
  username: '账号',
  email: '邮箱',
  realname: '真实姓名',
  role: '角色',
  userStatus: '用户状态',
  idNumber: '证件编号',
  address: '所属地',
  yes: '是',
  no: '否',
  typeCode1: '雇主',
  typeCode2: '人才',
  typeCode3: '财务',
  typeCode4: '超级管理员',
}


// WEBPACK FOOTER //
// ./src/common/lang/zh.js